import {PostDate} from "./postDate";
import { connect } from 'react-redux';

const CommentInner = ({comment, current_user, editComment, deleteComment})=>{
    const {user} = current_user;

    const content =comment.body.map((item,index)=>{
        if(item.type !== 'mention'){
            return item.content + " ";
        }else{
            return <span key={index+item.content} className={'mentionComment'}>{item.content} </span>
        }
    })

    return (<div className="postCommentWrapper">
      <div className={'postCommentContainer'}>
        <img alt={comment.user.firstname + " "+comment.user.lastname} className={'postCommentInputImg'} src={comment.user.img }/>
        <div className={'postCommentContentContainer'}>
            <div className={'topComment'}>
                <p className={'userName'}>{comment.user.firstname + " "+comment.user.lastname}</p>
                <PostDate date={comment.inserted_at}/>
            </div>
            <div className={"containerComment"}>
                <p className={'textComment'}>
                    {content}
                </p>
            </div>
        </div>
      </div>
      {
      user.role === "admin" && <div className="postCommentButtonWrapper">
        { /* <span className="postCommentButtonEdit" onClick={() => editComment(comment)} >Modifier</span> */ }
        <span className="postCommentButtonDelete" onClick={() => deleteComment(comment)} >Supprimer</span>
      </div>
      }
    </div>)
}


const mapStateToProps = (state) => ({current_user: state.current_user})

export const Comment =  connect(mapStateToProps, null)(CommentInner)
